
<div class="pending-sales">
  <page-header title="Pending Sales">
    <template #actions>
      <align>
        <span v-if="lastEbaySync">{{ $filters.datetime(lastEbaySync) }}</span>

        <icon-button
          tooltip="Generate Pending Sales"
          icon="update"
          :loading="scraping"
          @click="generatePendingSales"
        />

        <icon-button
          tooltip="Calculate Card Stats"
          icon="calculate"
          :loading="calculating"
          @click="calculateCardStats"
        />

        <icon-button
          tooltip="Generate Daily Sales Recap"
          icon="post_add"
          :loading="generating"
          @click="dailySalesRecap"
        />

        <icon-button
          tooltip="Submit all pending sales"
          icon="cloud_upload"
          :loading="submitting"
          @click="confirmAllPendingSales"
        />
      </align>
    </template>
  </page-header>

  <align flex collapse-end>
    <shared-filters
      show-recent-searches
      placeholder="Search"
      :filters.sync="filters"
      :sales-platforms="platformOptions"
      :query.sync="query"
      :properties="defaultFilters"
      @clear="clearFilters"
    />

    <align small-gap>
      <pill-dropdown
        v-model="employee"
        :options="employeeFilterOptions"
      />

      <pill-dropdown
        v-model="status"
        :options="statusOptions"
      />

      <direction-sort-options
        :sort.sync="sort"
        :direction.sync="direction"
        :options="sortOptions"
      />
    </align>
  </align>

  <filter-results
    is-filtering
    :filters="filters"
    :results="numResults"
    @clear="clearFilters"
  />

  <div class="results">
    <empty-state
      v-if="showEmptyState"
      icon="rowing"
      title="You are all caught up!"
    />

    <template>
      <section class="pending-sales-list">
        <pending-sales-item
          v-for="pendingSale in pendingSales"
          :id="pendingSale.itemId"
          :ref="`pending-sale-item-${pendingSale.itemId}`"
          :key="pendingSale.itemId"
          :sale="pendingSale"
          @remove="removePendingSaleFromList"
          @purgatory="sendToPurgatory"
        />
      </section>

      <div class="load-more-container">
        <btn
          v-if="hasMoreData"
          kind="secondary"
          loading-text="Loading"
          :loading="loading"
          @click="nextPage"
        >
          Load More
        </btn>
      </div>
    </template>
  </div>

  <scroll-top />
</div>
